import { useState } from "react";
import BaseDialog from "../../modelDialogs/BaseDialog";
import InstallationUtils from "../InstallationUtils";
import CheckEstadaBridgeStatusOnLocalhost from "../CheckEstadaBridgeStatusOnLocalhost";
import { isDevelopmentEnvironment } from "../../estada-config";
import { useRedraw } from "../../models/useRerender";
import { itx } from "../../translationItx/itx";

export default function InstallDialog(props: {}) {
  const redraw = useRedraw();

  const bridgeIsRunning = state.estadaBridgeIsRunning;
  let showOkButton = !bridgeIsRunning;

  if (isDevelopmentEnvironment()) {
    if (!bridgeIsRunning) {
      showOkButton = true;
    }
  }

  if (bridgeIsRunning && !state.settings.diagnosticMode) {
    showOkButton = true;
  }

  return (
    <BaseDialog
      title={state.translate("installDialog.installationModus", "Installations Modus")}
      abortCaption={
        state.settings.diagnosticMode
          ? itx("installDialog.leaveInstallModus", "Installations Modus verlasen")
          : undefined
      }
      onAbort={() => {
        InstallationUtils.stop();
        //
        state.settings.diagnosticMode = false;
        state.settings.raiseOnChange("diagnosticMode");

        return true;
      }}
      noOkButton={!showOkButton}
      okCaption={itx("installDialog.startInstallModus", "Start Installation-Mode")}
      onOk={() => {
        InstallationUtils.init();
        //
        state.settings.diagnosticMode = true;
        state.settings.raiseOnChange("diagnosticMode");

        return true;
      }}
    >
      <div style={{ width: "100%", display: "flex", alignContent: "center", justifyContent: "center" }}>
        <CheckEstadaBridgeStatusOnLocalhost
          onChange={(running) => {
            redraw();
          }}
        />
      </div>
    </BaseDialog>
  );
}
